import { Avatar, Box, Typography } from "@mui/material";

interface ProfileProps {
  picture: string;
  info?: string;
  name: string;
}

export const Profile = ({ picture, info, name }: ProfileProps) => {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%"
      }}
    >
      <Avatar src={picture} sx={{ marginRight: "10px" }}></Avatar>
      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          containerType: "inline-size",
          width: "100%"
        }}
      >
        <Typography sx={{ cursor: "text", userSelect: "text" }} onMouseDown={(e) => e.stopPropagation()} noWrap>
          {name}
        </Typography>
        {info && (
          <Typography sx={{ cursor: "text", userSelect: "text" }} onMouseDown={(e) => e.stopPropagation()} noWrap>
            {info}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
